/**
 * The 'in' operator requires at least 2 conditions (models) to work correctly.
 * If a user selects 'in' with multiple conditions and later removes some,
 * the operator must fall back to 'or' to avoid API mismatches.
 */
function normalizeOperator(operator, modelsCount) {
  if (modelsCount <= 1 && operator === 'in') {
    return 'or';
  }
  return operator;
}

export default normalizeOperator;
